module.exports = __webpack_public_path__ + "img/r1_921_people_children.5dc5a10b.jpg";